import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Offer from "./sections/Offer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <Story />
      <Offer />
    </div>;
}